import React from "react";
import { Link } from "react-router-dom";

import LogoSmallWhite from "../../assets/logo_small_white.png";
import styles from "./styles.module.scss";

const Footer: React.FC = () => {
  return (
    <div className={styles["container"]}>
      <p>Copyright © 2020 May Concrete Placers. All rights reserved.</p>
      <Link to="/">
        <img src={LogoSmallWhite} alt="" className={styles.logo} />
      </Link>
    </div>
  );
};

export default Footer;
